import { Link } from "react-router-dom";
import { ArrowRight, Printer } from "lucide-react";
import { Reveal } from "./Motion";
import { CHECKLIST } from "@/data/checklist";

export const ChecklistBand = ({ accent = "#B4532A" }) => (
  <section className="max-w-7xl mx-auto px-5 sm:px-8 pb-24" data-testid="checklist-band">
    <Reveal>
      <Link to="/checklist" data-testid="checklist-band-link" className="group grid lg:grid-cols-[1.3fr_1fr] gap-8 items-center rounded-[2rem] border border-[#E8DDD3] bg-white p-8 sm:p-12 transition-colors duration-500 hover:border-[#1F1A17]">
        <div>
          <div className="font-mono text-xs uppercase tracking-[0.25em]" style={{ color: accent }}>Free printable</div>
          <h2 className="mt-4 font-serif text-3xl sm:text-4xl tracking-tight text-[#1F1A17]">{CHECKLIST.title} — <em>print it, pour the tea.</em></h2>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-[#685F58]">{CHECKLIST.groups.length} short sections, {CHECKLIST.groups.reduce((n, g) => n + g.items.length, 0)} papers worth finding. Tick what you have, circle what you can't find. The circles are the plan.</p>
          <span className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#1F1A17] group-hover:bg-[#B4532A] h-12 px-6 text-sm font-medium text-[#FBF8F4] transition-colors duration-300">
            <Printer className="h-4 w-4" /> Open the checklist <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </span>
        </div>
        <ul className="hidden lg:grid grid-cols-2 gap-x-6 gap-y-2.5 rounded-2xl bg-[#FBF8F4] border border-[#E8DDD3] p-6 -rotate-1 group-hover:rotate-0 transition-transform duration-500">
          {CHECKLIST.groups.map((g) => (
            <li key={g.t} className="flex items-center gap-2.5 text-sm text-[#1F1A17]"><span className="h-3.5 w-3.5 rounded border border-[#1F1A17]/50" />{g.t}</li>
          ))}
        </ul>
      </Link>
    </Reveal>
  </section>
);
